import React from 'react'
import { Select, Icon } from '@st-operations/uikit/src/v2'

const Pagination = ({ pages, page, setPage }) => {
  return (
    <div className="ac-seeds-block__pagination">
      <button
        type="button"
        className="ac-seeds-block__pagination-button ac-seeds-block__pagination-button--left"
        onClick={() => setPage(page - 1)}
        disabled={page <= pages[0] ? 1 : 0}
      >
        <Icon icon="angledown" type="fill" />
      </button>
      <Select
        isClearable={false}
        onChange={({ value }) => setPage(value)}
        options={pages}
        value={page}
        useReactSelect
        menuPlacement="top"
      />
      <span>{`of ${pages.length}`}</span>
      <button
        type="button"
        className="ac-seeds-block__pagination-button ac-seeds-block__pagination-button--right"
        onClick={() => setPage(page + 1)}
        disabled={page >= pages[pages.length - 1] ? 1 : 0}
      >
        <Icon icon="angledown" type="fill" />
      </button>
    </div>
  )
}

export default Pagination
